<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch08"></a><a id="page_9"></a><a href="#/contents#ch08"><b>Ancient Eating</b></a></h2>
<p class="noindent"><span>In ancient Rome, it was considered a sin to eat a woodpecker.</span></p>
<p class="noindent"><span>The first volume of published recipes dates to AD 62. Titled <i>De re coquinaria</i> (“On the Subject of Cooking”), it described the feasts enjoyed by the Roman emperor Claudius.</span></p>
<p class="noindent"><span>The first archaeological evidence of soup dates back to 6000 BC. The main ingredient was hippopotamus.</span></p>
<p class="noindent"><span>Romans did not eat sitting up—that was considered extremely bad manners. They ate lying down on couches around the table.</span></p>
<p class="noindent"><span>The oldest known sample of a chewing gum was found in Sweden in 1993. The 9,000-year-old gob of honey-sweetened resin still contained tooth marks.</span></p>
<p class="noindent"><span>In the 13th century, quality standards for pasta were set by the pope.</span></p>
<p class="noindent"><span>Romans flavored food with garum, a paste made by leaving fish to rot for several weeks.</span></p>
<p class="noindent"><span>Pepper was so valuable during Elizabethan times that it was sold by the individual grain.</span></p>
<p class="noindent"><span>The ancient Romans had soft drinks of root juices and water.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter08.vue?46a8cf93